import { useEffect, useState } from 'react';

import transformAdminNavigationData from '../TransformConfig/Admin';
import transformLearnerNavigationData from '../TransformConfig/Learner';

import { getAdminIsTabEnabledMap } from '../TransformConfig/Admin/utils';
import { getLearnerIsTabEnabledMap } from '../TransformConfig/Learner/utils';
import { getNavigationDataResponse } from '../api';
import { NavRouteStaticDataType } from '../types';

import { isAdminSite } from '../../../utils';
import { AdminNavRouteStaticDataType } from '../TransformConfig/Admin/types';
import { LearnerNavRouteStaticDataType } from '../TransformConfig/Learner/types';

const useNavigationData = () => {
  const [navConfig, setNavConfig] = useState<NavRouteStaticDataType[] | []>([]);
  const [navConfigError, setNavConfigError] = useState(null);
  const [navDataLoaded, setNavDataLoaded] = useState(false);
  const [navEnabledMap, setNavEnabledMap] = useState<Record<string, boolean>>({});
  useEffect(() => {
    getNavigationDataResponse()
      .then(data => {
        const response = Object.values(data) as NavRouteStaticDataType[];
        const transformedData = isAdminSite()
          ? transformAdminNavigationData(response)
          : transformLearnerNavigationData(response);

        const navEnabledMap = isAdminSite()
          ? getAdminIsTabEnabledMap(transformedData as AdminNavRouteStaticDataType[])
          : getLearnerIsTabEnabledMap(transformedData as LearnerNavRouteStaticDataType[]);

        setNavConfig(transformedData);
        setNavEnabledMap(navEnabledMap);
        setNavDataLoaded(true);
      })
      .catch(err => {
        setNavConfigError(err);
      });
  }, []);

  return {
    navConfig,
    navConfigError,
    navDataLoaded,
    navEnabledMap,
  };
};

export default useNavigationData;
